
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/purchasely",
      function () {
        return require("private-next-pages/destinations/purchasely.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/purchasely"])
      });
    }
  